// =========================================================================================@@
// Last Updated Date: Mar 29, 2022
// Last Updated By: Steven Yuen
// Status Level: 2
// ===========================================================================================

import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import InitiativeMoreButton from 'src/sites/kits/Initiative/components/MoreButton'
import ObjectJoinButton from 'src/sites/kits/Object/components/JoinButton'
import ObjectSubscribeButton from 'src/sites/kits/Object/components/SubscribeButton'
import UserBadgeSash from 'src/sites/kits/People/components/UserBadgeSash'
import { InitiativeHierarchyContext } from 'src/sites/kits/Utils/InitiativeHierarchy'

const ObjectActionBar = ({ showOriginalAuthor }) => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   const isDraft = initiative.privacy === 'draft'
   const primaryRole = initiative.roles.find(r => r.type === 'primary')
   const showNumMembers = ['event', 'group'].includes(initiative.class) &&
      primaryRole?.numActiveUsers > 1

   const avatarUrl = initiative.addedBy.avatarMedia
      ? initiative.addedBy.avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <View
         display="flex"
         width="100%"
         alignItems="center"
         justifyContent={(showOriginalAuthor || showNumMembers)
            ? 'space-between'
            : 'flex-end'
         }
         borderTop="1px solid #eee"
         paddingTop="30px"
         marginBottom="30px">
         {/* TODO: Will use in the future PR #967
            {showNumMembers && (
            <View display="none[a] flex[b-f]" alignItems="center">
               <View marginRight="15px">
                  <CheckmarkIcon width="12px" height="12px" color="#888" />
               </View>
               <Text
                  color="#888"
                  size="2"
                  lineHeight="160%">
                  {initiative.class === 'event'
                     ? `${primaryRole.numActiveUsers} people are attending this event`
                     : `${primaryRole.numActiveUsers} people are part of this group`
                  }
               </Text>
            </View>
         )} */}
         {showOriginalAuthor && (
            <View
               display="flex"
               alignItems="center"
               flex="1 1 auto">
               <View
                  flex="0 0 auto"
                  float="left"
                  width="30px"
                  height="30px"
                  borderRadius="3px"
                  backgroundColor="#ddd"
                  backgroundImage={`url(${avatarUrl})`}
                  backgroundSize={initiative.addedBy.avatarMedia
                     ? 'cover'
                     : '21px 21px'
                  }
                  backgroundPosition="bottom center"
                  backgroundRepeat="no-repeat"
                  marginRight="15px"
               />
               <Text color="#888" size="1.5">
                  By
                  &nbsp;
                  <Link to={`/-/profile/${initiative.addedBy.id}`}>
                     <Text
                        style={{ display: 'inline-block' }}
                        color="#222"
                        size="2"
                        weight="medium">
                        {initiative.addedBy.fullName}
                     </Text>
                  </Link>
                  <UserBadgeSash
                     badges={initiative.addedBy.badges}
                     style={{ margin: '0px 5px' }}
                  />
                  <br />
                  {initiative.dateAdded}
               </Text>
            </View>
         )}

         <View display="flex" alignItems="center" width="100%[a]">
            <View flex="1 1 auto">
               {!isDraft && initiative.class === 'discussion' && (
                  <ObjectSubscribeButton />
               )}
               {initiative.class !== 'discussion' && (
                  <ObjectJoinButton
                     buttonRounded
                     buttonSize="lg"
                     buttonWidth="100%"
                     popoverAnchorOriginVertical="bottom"
                  />
               )}
            </View>
            {initiative.currentUserCanEdit && (
               <View flex="0 0 auto" marginLeft="3px">
                  <InitiativeMoreButton
                     buttonSize="lg"
                     buttonWidth="30px"
                     popoverAnchorOriginVertical="top"
                  />
               </View>
            )}
         </View>
      </View>
   )
}

ObjectActionBar.propTypes = {
   showOriginalAuthor: PropTypes.bool
}

ObjectActionBar.defaultProps = {
   showOriginalAuthor: false
}

export default ObjectActionBar
